import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { CsBuildupStateQuery, CsBuildupStateStore, EditableSectionPartComponent } from '../../shared';

@Component({
  selector: 'app-installation-description',
  templateUrl: './installation-description.component.html',
  styleUrls: ['./installation-description.component.scss']
})
export class InstallationDescriptionComponent extends EditableSectionPartComponent implements OnInit, OnChanges, OnDestroy {
  @Input() text?: string;
  @Output() discardChangesCalled = new EventEmitter();
  @Output() saveChangesCalled = new EventEmitter<string>();
  @Output() deleteCalled = new EventEmitter();
  internalText?: string;

  constructor(
    protected element: ElementRef<Element>,
    protected csBuildupStore: CsBuildupStateStore,
    protected csBuildupStateQuery: CsBuildupStateQuery) {
    super(element, csBuildupStore, csBuildupStateQuery);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.internalText = changes.text.currentValue;
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  discardChanges(): void {
    this.internalText = this.text;
    this.discardChangesCalled.emit();
    this.endEdit();
  }

  saveChanges(): void {
    this.text = this.internalText;
    this.saveChangesCalled.emit(this.internalText);
    this.endEdit();
  }

  delete(): void {
    this.deleteCalled.emit();
  }
}
